import React, { Component } from 'react';
import { SearchSchoolFilter } from './SearchSchoolFilter';
import PropTypes from 'prop-types';
import { SearchSchoolResultGroup } from './SearchSchoolResultGroup';
import { SearchSchoolCart } from './InSchoolCart/SearchSchoolCart';

export class SearchSchoolComponent extends Component {

  constructor(props) {
    super(props);

    // TODO store filters in localstorage??

    this.state = {
      filterSubject: null,
      filterLevel: null,
      filterLocation: null,
    };
  }

  /**
     * Sets the filters state
     *
     * This method is triggered by the SearchSchoolFilter
     * component
     *
     * @param e
     */
  onChangeFilter(e) {
    let { name, value } = e.target;

    switch (name) {
      case 'vak_naam':
        this.setState({ filterSubject: value });
        break;
      case 'vak_niveau':
        this.setState({ filterLevel: value });
        break;
      case 'loc_naam':
        this.setState({ filterLocation: value });
        break;
    }
  }

  /**
     * Filter the list of trainings by the filters set
     * in the state
     *
     * @param trainings
     * @returns {*}
     */
  filterResults(trainings) {
    const { filterSubject, filterLevel, filterLocation } = this.state;
    let filterResults = trainings;

    if (filterSubject) {
      filterResults = filterResults
        .filter(training => filterSubject === training.vak_naam);
    }

    if (filterLevel) {
      filterResults = filterResults
        .filter(training => filterLevel === training.vak_niveau);
    }

    if (filterLocation) {
      filterResults = filterResults
        .filter(training => filterLocation === training.loc_naam);
    }

    return filterResults;
  }

  /**
     * Group the trainings by the datum_start field
     *
     * @param trainings
     * @returns {any[]}
     */
  groupTrainingsByPeriod(trainings) {
    const periods = new Map();

    trainings.map(training => {
      // check if hasProp otherwise add : []
      if (!periods.has(training.datum_start)) {
        periods.set(training.datum_start, []);
      }
      let periodTraining = periods.get(training.datum_start);
      periodTraining.push(training);
      periods.set(training.datum_start, periodTraining);
    });

    return Array.from(periods.values());
  }

  render() {
    const { trainings, post } = this.props;

    const locations = trainings.map(training => training.loc_naam);
    const uniqueLocations = [...new Set(locations)];

    const filteredTrainings = this.filterResults(trainings);
    const periods = this.groupTrainingsByPeriod(filteredTrainings);

    const resultGroups = periods.map((period, key) => {
      return (<SearchSchoolResultGroup
        key={key}
        trainings={period}
        post={post}/>);
    });

    return (
      <div>

        <SearchSchoolFilter
          trainings={trainings}
          locations={uniqueLocations}
          numResults={filteredTrainings.length}
          onChangeFilter={filter => this.onChangeFilter(filter)}/>
        <div className="container">

          {post.wide_alert.notice
          && <div className="school-page__form-notice">
            <div className="school-page__form-notice-content">
              { post.wide_alert.notice }
            </div>
            <a className="btn btn-ghost-white"
               target={post.wide_alert.button.target}
               href={post.wide_alert.button.url}>
              { post.wide_alert.button.title }
            </a>
          </div>}

          <div className="row">
            <div className="col-md-12">
              <div className="school-page__summary">
                <strong>{filteredTrainings.length} trainingen</strong> beschikbaar
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="school-page__results">
                {resultGroups.length === 0 && <NoSchoolResultsFound/>}
                {resultGroups}
              </div>
            </div>
            <div className="col-md-4">
              <SearchSchoolCart trainings={trainings} post={post}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchSchoolComponent.propTypes = {
  trainings: PropTypes.arrayOf(PropTypes.object),
  post: PropTypes.object,
};


export class NoSchoolResultsFound extends Component {
  render() {
    return (
      <div className="school-page__result-group">
        <h3>Geen trainingen beschikbaar met de opgegeven criteria.</h3>
                Bel voor de laatste mogelijkheden:<strong> 071 - 79 000 40</strong>
      </div>);
  }
}
